import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import moment from "moment";
import { SCIENTIFIC_COUNCIL_NEW } from "constants/selectOptions";

function DuplicateCheckModal({ open, handleClose, duplicateList, handleSelect }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <WarningIcon style={{ color: "#ff9800", marginRight: 8 }} />
          <Typography variant="h6">Phát hiện hội đồng trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các hội đồng có tiêu đề tương tự. Vui lòng kiểm tra và chọn chỉnh sửa nếu đây là hội đồng
          đã tồn tại.
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Tiêu đề</b>
                </TableCell>
                <TableCell>
                  <b>Ngày tổ chức</b>
                </TableCell>
                <TableCell>
                  <b>Loại hội đồng</b>
                </TableCell>
                <TableCell>
                  <b>Thao tác</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicateList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item?.title || "-"}</TableCell>
                  <TableCell>
                    {item?.executionTime ? moment(item.organizationDate).format("DD/MM/YYYY") : "-"}
                  </TableCell>
                  <TableCell>
                    {SCIENTIFIC_COUNCIL_NEW.councilType.find((e) => e.value === item?.type).title || "-"}
                  </TableCell>
                  <TableCell>
                    <Button size="small" variant="contained" color="primary" onClick={() => handleSelect(item)}>
                      Chỉnh sửa
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DuplicateCheckModal;

